import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { IndividualRenewalService } from '../individual-renewal.service';
import { StartFunctionService } from '../../../shared/utils/start-function.service';
import { StorageService } from '../../../shared/security/StorageService';
import { CurrentPageWatcherService } from '../../../shared/utils/CurrentPageWatcher';
import { SpinnerService } from '../../../shared/spinner/spinner.service';
import { Router } from '@angular/router';
import { StartFunctionResponseModel } from '../../../model/startFunctionResponseModel';
import { WorkflowModel } from '../../../model/workflowModel';
import { QuestionnaireQuestionModel } from '../../../model/questionnaireQuestionModel';
import { MessageModel } from '../../../model/models';
import * as $ from 'jquery';
import { EntityRenewalService } from '../../entity-renewal/entity-renewal.service';

@Component({
  selector: 'app-individual-questionnaire',
  templateUrl: './individual-questionnaire.component.html',
  styleUrls: ['./individual-questionnaire.component.css']
})
export class IndividualQuestionnaireComponent implements OnInit, OnDestroy {
  startFunction: StartFunctionResponseModel = {};
  workflow: WorkflowModel = new WorkflowModel();
  questions: Array<QuestionnaireQuestionModel> = [];
  userMessages: Array<MessageModel> = [];
  text: string = "<b>Since the issuance of your current or most recent license:</b>";

  constructor(private individualRenewalService: IndividualRenewalService,
    private startFunctionService: StartFunctionService,
    private storage: StorageService,
    private currentPageWatcher : CurrentPageWatcherService,
    private spinner: SpinnerService,
    private router : Router,
    private entityRenewalService : EntityRenewalService) { 

      this.startFunction = this.storage.getStartFunctionData(); 
      if(this.entityRenewalService.renewalWorkflowModel == undefined || this.entityRenewalService.renewalWorkflowModel==null){
        this.workflow = this.startFunction.Workflow;
      }
      else{
        this.workflow = this.entityRenewalService.renewalWorkflowModel;
      }

    }

  ngOnInit() {
    this.individualRenewalService.getIndividualQuestionnaire(this.workflow.WorkflowID).subscribe(
      (questionnaireListResp: QuestionnaireQuestionModel[]) => {
        this.questions = questionnaireListResp;
        this.individualRenewalService.questionnaireQuestionModel = questionnaireListResp;
      });
  }

  verifyQuestionnaire(){
    if (this.questions.filter(el => el.Answer != null).length != this.questions.length) {
      let userMessage: MessageModel = {};
      userMessage.Alert = 3;
      userMessage.Description = "You must answer all of the questions.";
      this.userMessages.push(userMessage);
      $("html, body").animate({ scrollTop: 0 }, "slow");
      this.currentPageWatcher.sendUserMessages(this.userMessages);
      this.userMessages = [];
    }
    else {
      this.router.navigate(["/verifyIndividualRenewalQuestionnaire"]).then(() => {
        this.startFunctionService.getNotifyStepInProgress().emit(true);
        this.individualRenewalService.getNotifyIndividualQuestionList().emit(this.questions);
      })
    }
  }

  goBack(){
    //startIndividualRenewal
    this.router.navigate(["/startIndividualRenewal"]).then(() => {
      this.startFunctionService.getNotifyStepInProgress().emit(false);
    })
  }


  @HostListener('window:popstate', ['$event'])
  onPopState(event) {
    this.startFunctionService.getNotifyStepInProgress().emit(false);
  }

  ngOnDestroy(): void {
    this.currentPageWatcher.clearUserMessage();
  }

}



// WEBPACK FOOTER //
// ./src/app/renewal/individual-renewal/individual-questionnaire/individual-questionnaire.component.ts